import { COUNTRY_ISO_NUM } from "constants/validationConstants";

/**
 * Indica si un país (isoNum) corresponde a Colombia.
 * Usa comparación laxa porque el valor puede llegar como número o string.
 * @param {string|number} country isoNum del país
 * @returns {boolean}
 */
export function isColombia(country) {
    // eslint-disable-next-line eqeqeq
    return country == COUNTRY_ISO_NUM.COLOMBIA;
}

export function capitalizeEveryWord(word) {
    if (!word) return '';
    
    return word
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
